module.exports = __webpack_public_path__ + "static/2p-9d0cafccdd779a571987d2e8f352cd3c.webp";